import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.o6p_1 = partyId;
        this.p6p_1 = pinId;
        this.q6p_1 = icon;
        this.r6p_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.o6p_1.toString() + ', pinId=' + this.p6p_1.toString() + ', icon=' + this.q6p_1 + ', name=' + this.r6p_1 + ')';
      }
      hashCode() {
        var result = this.o6p_1.hashCode();
        result = imul(result, 31) + this.p6p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.q6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.o6p_1.equals(other.o6p_1))
          return false;
        if (!this.p6p_1.equals(other.p6p_1))
          return false;
        if (!(this.q6p_1 === other.q6p_1))
          return false;
        if (!(this.r6p_1 === other.r6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
